import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocationTypes } from '../models/locationtypes';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocationtypeService {

  public httpOptions: {};

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem("access_token")}` })
    };
  }

  getAllLocationTypes(): Observable<any> {
    return this.http.get('/api/LocationType/getAllLocationTypes', this.httpOptions);
  }  

  saveLocationType(locationType: LocationTypes) {
    return this.http.post('/api/LocationType/saveLocationType', locationType, this.httpOptions)
      .pipe(
        map((res: Response) => {
          let body = res;// .json();
          return body
            || {};
        }));
  }

  updateLocationType(locationType: LocationTypes) {
    return this.http.post('/api/LocationType/updateLocationType', locationType, this.httpOptions)
      .pipe(
        map((res: Response) => {
          let body = res;// .json();
          return body
            || {};
        }));
  }

  deleteLocationType(locationType) {
    return this.http.post('/api/LocationType/deleteLocationType', locationType, this.httpOptions)
      .pipe(
        map((res: Response) => {
          let body = res;// .json();
          return body
            || {};
        }));
  }
}
